import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { createSlotsContext } from '@grandvisionhq/slots';
import { DeliveryMethod } from '../../models/details-order.js';
import { ShippingSummarySlotTypes } from './types.js';

var ShippingObjectTypes;
(function(ShippingObjectTypes) {
    ShippingObjectTypes["BillingAddress"] = 'billingAddress';
    ShippingObjectTypes["DeliveryAddress"] = 'deliveryAddress';
    ShippingObjectTypes["ContactDetails"] = 'contactDetails';
    ShippingObjectTypes["Company"] = 'company';
    ShippingObjectTypes["Invoice"] = 'invoice';
    ShippingObjectTypes["ExpressCheckout"] = 'expressCheckout';
})(ShippingObjectTypes || (ShippingObjectTypes = {}));
const [OrderDetailsSummariesSlotsProvider, useBaseSummarySlot] = createSlotsContext({
    displayName: 'OrderDetailsSummaryContext'
});
const useOrderDetailsSummariesSlot = (orderData)=>{
    const { Slots  } = useBaseSummarySlot();
    /**
   *  Iterate over all summary components passed by opco
   *  Bind data to summary component
   **/ const summaries = Object.entries(Slots).reduce((summaryItem, [key, Slot])=>{
        let summaryData = orderData && orderData[key];
        if (orderData && key === ShippingObjectTypes.ContactDetails) {
            const { firstName , lastName  } = orderData[ShippingObjectTypes.BillingAddress];
            summaryData = swcHelpers.objectSpread({
                firstName,
                lastName
            }, orderData.customerDetails);
        }
        if (orderData && key === ShippingObjectTypes.Company) {
            const { company  } = orderData[ShippingObjectTypes.BillingAddress];
            const { customerVatId , secondaryEmail  } = orderData[ShippingObjectTypes.Invoice];
            summaryData = swcHelpers.objectSpread({
                name: company,
                customerVatId,
                secondaryEmail
            }, summaryData);
        }
        if (key === ShippingSummarySlotTypes.Addresses) {
            const billingAddress = orderData === null || orderData === void 0 ? void 0 : orderData.billingAddress;
            const deliveryAddress = orderData === null || orderData === void 0 ? void 0 : orderData.shippingAddress;
            const isAddressesEqual = (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.postalCode) === (deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.postalCode) && (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.streetName) === (deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.streetName) && (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.streetNumber) === (deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.streetNumber);
            const isPickupOrder = (orderData === null || orderData === void 0 ? void 0 : orderData.deliveryMethod) === DeliveryMethod.Pickup || (orderData === null || orderData === void 0 ? void 0 : orderData.deliveryMethod) === DeliveryMethod.PickupPoint;
            summaryData = {
                billingAddress,
                deliveryAddress,
                isAddressesEqual,
                isPickupOrder
            };
        }
        summaryItem[key] = /*#__PURE__*/ React.createElement(Slot, {
            "data-t": `${key}Summary`,
            actions: undefined,
            values: summaryData
        });
        return summaryItem;
    }, {});
    return summaries;
};

export { OrderDetailsSummariesSlotsProvider, ShippingObjectTypes, useBaseSummarySlot, useOrderDetailsSummariesSlot };
//# sourceMappingURL=order-details-summary-context.js.map
